// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app{display:flex;flex-direction:column;align-items:center;overflow:hidden}a{color:inherit}.display-popup-root-div{display:inline-block}.text-preview-image{text-align:center;padding:3px}.p-sidebar-content{height:100vh;overflow:hidden}", ""]);
// Exports
module.exports = exports;
